<script setup lang="ts">
import { ref } from "vue";

import { primaryColors, useTheme } from "@/layout/composables/theme.ts";

const popover = ref();

const { currentPrimaryColor } = useTheme();
</script>

<template>
  <Button variant="text" icon="pi pi-palette" @click="(e) => popover?.toggle(e)" />
  <Popover ref="popover" class="p-2">
    <div class="grid grid-cols-8 gap-2">
      <button
        v-for="[name, palette] of Object.entries(primaryColors)"
        :key="name"
        type="button"
        :class="[
          'cursor-pointer w-5 h-5 rounded-full flex shrink-0 items-center justify-center p-0 outline-primary outline-offset-1',
          { 'outline-2': currentPrimaryColor === name },
        ]"
        :style="{
          backgroundColor: `${name === 'noir' ? 'var(--text-color)' : palette['500']}`,
        }"
        @click="currentPrimaryColor = name"
      />
    </div>
  </Popover>
</template>
